let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l4YQq")).then(() => parcelRequire('6xXQU'));